import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { ButtonLabel } from '../button/Button';
import { RouterLink } from '../link/RouterLink';
import {
	ArrowForwardIcon,
	DownloadIcon,
	EmailIcon,
	ExternalLinkIcon,
	PhoneIcon,
	ITheme,
} from '../../../ui';
import { ArrowLinkStyles } from '../button/ArrowLinkStyles';

export interface IQuickLinkProps {
	type:
		| 'email'
		| 'external'
		| 'internal'
		| 'asset'
		| 'phone'
		| 'externalSecondary';
	url: string;
	ariaLabel?: string;
	children: ReactNode;
}

export function QuickLink({ type, url, ariaLabel, children }: IQuickLinkProps) {
	const ICON_MAP = {
		email: <EmailIcon aria-hidden />,
		external: <ExternalLinkIcon aria-hidden />,
		internal: <ArrowForwardIcon aria-hidden />,
		asset: <DownloadIcon aria-hidden />,
		phone: <PhoneIcon aria-hidden />,
		externalSecondary: null,
	};

	const icon = ICON_MAP[type];
	const openInNewTab = [
		'external',
		'asset',
		'email',
		'externalSecondary',
	].includes(type);

	return (
		<StyledLink
			href={url}
			target={openInNewTab ? '_blank' : undefined}
			aria-label={`${ariaLabel} ${openInNewTab ? '(opens in a new tab)' : ''}`}
		>
			<ButtonLabel>{children}</ButtonLabel>
			{icon}
		</StyledLink>
	);
}

const StyledLink = styled(RouterLink)<{}, ITheme>`
	display: flex;
	align-items: center;
	text-decoration: none;
	max-width: fit-content;
	font-weight: 700;
	${(props) => ArrowLinkStyles(props.theme)};

	&:focus {
		background-color: ${(props) =>
			props.theme.button.textButton.focus.background};
		border: ${(props) => props.theme.button.textButton.focus.border};
	}
	&:active {
		background-color: ${(props) =>
			props.theme.button.textButton.active.background};
		border: ${(props) => props.theme.button.textButton.active.border};
		color: ${(props) => props.theme.button.textButton.active.font.color};
	}
`;
